import { render, staticRenderFns } from "./LoadingContent.vue?vue&type=template&id=66ed7cc6&"
import script from "./LoadingContent.vue?vue&type=script&lang=js&"
export * from "./LoadingContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports